const getStoredString = (key: string, fallback: string): string => {
  const value = localStorage.getItem(key);
  if (value && value !== "undefined" && value !== "null") {
    return value;
  }
  localStorage.setItem(key, fallback);
  return fallback;
};

const getStoredBoolean = (key: string, fallback: boolean): boolean => {
  const value = localStorage.getItem(key);
  if (value === "true") {
    return true;
  }
  if (value === "false") {
    return false;
  }
  localStorage.setItem(key, String(fallback));
  return fallback;
};

export class NextConfig {
  public static config = {
    layout: "vertical", // vertical, horizontal
    subLayout: "", // horizontal-2
    collapseMenu: getStoredBoolean("collapseMenu", false), // true of false
    layoutType: getStoredString("layoutType", "menu-dark"), // menu-dark, menu-light, dark, light, red
    headerBackColor: getStoredString("headerBackColor", "background-img-2"), // background-*, background-grd-*, background-img-*
    rtlLayout: getStoredBoolean("rtlLayout", false),
    navFixedLayout: getStoredBoolean("navFixedLayout", false),
    headerFixedLayout: getStoredBoolean("headerFixedLayout", false),
    boxLayout: getStoredBoolean("boxLayout", false),
  };
}
 
